import Modal from '../..';
import Form from '../../../Form';
import useStore from '../../../Hooks/useStore';

export interface ModalCompanyFilterProps {}

const ModalCompanyFilter = ({}: ModalCompanyFilterProps) => {
  const [getters, setters] = useStore();
  const {
    modal: { getModal },
  } = getters;
  const {
    modal: { closeSingleModal },
  } = setters;

  const isOpen = getModal('single.filterCompany');

  const onClose = () => {
    closeSingleModal('filterCompany');
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      headerTitle={'Filtro de companhias'}
      height={'calc(100vh - 70px)'}
      width={'550px'}
      alignment="right"
    >
      <Form.Export.Company.Filter />
    </Modal>
  );
};

export default ModalCompanyFilter;
